export default __webpack_public_path__ + "static/GT-America-Standard-Regular-1871a1ed30aac445bad437fa5c2f495d.woff2";